import React from "react";

const TableImage = ({ value }) => {
  return <div>{value ? <img style={{ maxWidth: 100 }} src={value} /> : "No image"}</div>;
};

export default TableImage;
